import { enterpriseEndpoints } from "@omega/omp-api";
import type { RequestConfig } from "@app/config/axios/http";
import { ompTransport } from "@src/api/ompTransport";
import type { Enterprise, EnterpriseFilter } from "./types";

/**
 * Транспортный слой OMP — предприятия.
 * Контракт и wire-формат — из пакета `@omega/omp-api`.
 */
export const enterpriseApi = {
    /**
     * Загружает предприятия по фильтру.
     * @param params фильтр предприятий
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: EnterpriseFilter;
        },
        config?: RequestConfig,
    ): Promise<Enterprise[]> => {
        return enterpriseEndpoints.loadByFilter.call(ompTransport, params.flt ?? {}, config);
    },
} as const;
